import {
  ICustomProperties,
  IDependencyTelemetry,
  IExceptionTelemetry,
  IMetricTelemetry,
  ITraceTelemetry,
} from '@microsoft/applicationinsights-web';

export abstract class TelemetryService {
  abstract trackTrace(
    message: ITraceTelemetry,
    properties?: ICustomProperties,
  ): void;
  abstract trackDependencyData(dependency: IDependencyTelemetry): void;
  abstract trackMetric(
    metric: IMetricTelemetry,
    properties?: ICustomProperties,
  ): void;
  abstract trackException(
    exception: IExceptionTelemetry,
    properties?: ICustomProperties,
  ): void;
  abstract flush(): void;
}
